import { globalStores } from '@/editor/stores';
import FloorPlane from '@/editor/entities/plane/floorPlane';
import { ENTITY_PRIORITY, ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { computeBoundingBox, disposeAllChildrenThenRemoveFromParent } from '@/editor/entities/utils';
import { EContainerType, EEntityStatus } from '@/editor/types/entity';
import { EEntityType, IWallEdge } from '@/editor/types';
import BaseModel2d from './BaseModel2d';
import MaskPlane from '../plane/maskPlane';
import { IMaterialInfo } from '@/editor/data/material/material';
import { getPathFromEdges } from '@/editor/utils/edge';

interface IParams {
  id: string;
  materialInfo: IMaterialInfo;
  corePathInfos: IWallEdge[];
  coreHoleInfos: IWallEdge[][];
}

class RegionModel extends BaseModel2d {
  private _plane?: FloorPlane;
  private _maskPlane?: MaskPlane;

  constructor(regionData: IParams) {
    super();

    this._modelGroup.userData.containerType = EContainerType.entity;
    this._modelGroup.userData.entityId = regionData.id;
    this._modelGroup.userData.type = EEntityType.Region;
    this._modelGroup.userData.priority = ENTITY_PRIORITY.region;

    this.updateModel(regionData);
    this.setDisplayOrder(ENTITY_RENDER_ORDER.region);
    globalStores.editorStateStore.sceneInfo.scene2d.intersectableGroup.add(this._modelGroup);
  }

  setStatus(_updateData: { color: number; lineWidth: number; status?: EEntityStatus; selected?: boolean }) {}

  updateModel(regionData: IParams) {
    const path = getPathFromEdges(regionData.corePathInfos);
    const holes = regionData.coreHoleInfos.map((holes) => getPathFromEdges(holes));

    if (!this._plane) {
      this._plane = new FloorPlane(path, holes, EEntityType.Region, regionData.materialInfo);
      this._modelGroup.add(this._plane.floorMesh);
      if (!this._maskPlane) this._maskPlane = new MaskPlane(path, holes, EEntityType.Region);
      this._modelGroup.add(this._maskPlane.floorMesh);
    } else {
      this._plane.updateFloorPlane(path, holes);
      this._plane.modifyFloorMaterial(regionData.materialInfo);
      this._maskPlane?.updateMaskFloorPlane(path, holes);
    }
  }

  setFloorPlaneStatus(enable: boolean) {
    if (this._maskPlane) {
      this._maskPlane.setVisible(!enable);
    }
  }

  override getBoundingBox() {
    return computeBoundingBox(this._modelGroup);
  }

  override dispose() {
    disposeAllChildrenThenRemoveFromParent(this._modelGroup);
  }
}

export default RegionModel;
